import react from "react";
import { Box, Paper } from "@mui/material";
import muiTheme from "../../../themes/muiTheme";

interface Props {
  isShowDrawer: boolean;
  isPortrait: boolean;
  setIsOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DrawerButton = ({
  isShowDrawer,
  isPortrait,
  setIsOpenDrawer,
}: Props) => {
  return (
    <Paper
      onClick={() => setIsOpenDrawer(!isShowDrawer)}
      elevation={0}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        width: 52,
        height: 52,
        position: "fixed",
        top: 0,
        right: 0,
        bgcolor: muiTheme.palette.blue[500],
        borderRadius: 0,
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        zIndex: 1,
        ":hover": {
          backgroundColor: isPortrait ? null : muiTheme.palette.blue[600],
        },
      }}
    >
      <Box
        component="img"
        src={process.env.PUBLIC_URL + "/img/ic_menu.png"}
        sx={{ width: 24, height: 24 }}
        zIndex={1}
      />
    </Paper>
  );
};
